export const seo = {
  title: 'Offers | Gousto',
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
    {
      name: 'og:description',
      content: 'Save on your first Gousto recipe boxes with our latest offers.',
    },
    {
      name: 'og:type',
      content: 'website',
    },
    {
      name: 'og:url',
      content: 'https://www.gousto.co.uk/ppcb',
    },
  ],
}
